import { configureStore } from "@reduxjs/toolkit";
import languageReducer from "./languageSlice";
import reportSlice from "./reportSlice";
import querySlice from "./querySlice";
import vendorSlice from "./vendorSlice";

const store = configureStore({
  reducer: {
    language: languageReducer,
    reports: reportSlice,
    queries: querySlice,
    vendors: vendorSlice
  },
});

export default store;
